import Markdown from "./Markdown.js";
import { createTextArea } from "./factory.js";
export default createTextArea({
  Markdown,
  useMinHeight: true
});